<template>
    <b-card no-body style="width: 100%;">
        <b-card-body class="chart-container">
            <apexchart type="pie" width="380" :options="chartOptions" :series="series"></apexchart>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    props: ['gendersData'],
    data() {
        return {
            series: [], // Will be populated dynamically
            chartOptions: {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                title: {
                    text: "نوع الطلاب", // Arabic title for the chart
                    align: 'center',
                    style: {
                        fontSize: '22px',
                        fontFamily: 'droid', // Use your desired font
                    },
                },
                labels: [], // Will be populated dynamically
                dataLabels: {
                    enabled: true, // Enable data labels
                    style: {
                        fontSize: '18px', // Font size for the labels
                        fontFamily: 'droid', // Font family for the labels
                        fontWeight: 'bold', // Make the labels bold
                        colors: ['#ffffff'], // Text color for the labels (white in this case)
                    },
                    formatter: function (val, { seriesIndex, w }) {
                        // Display the percentage inside the slice
                        return w.config.series[seriesIndex];
                    },
                    offsetY: 0, // Adjust vertical position of the labels
                    dropShadow: {
                        enabled: false, // Disable drop shadow for labels
                    },
                },
                legend: {
                    position: 'bottom', // Position the legend at the bottom
                    fontSize: '14px', // Font size for the legend
                    fontFamily: 'droid', // Font family for the legend
                    labels: {
                        colors: ['#333333'], // Text color for the legend
                    },
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                }],
            },
        };
    },
    watch: {
        gendersData: {
            immediate: true,
            handler(newVal) {
                // Update series and labels dynamically based on gendersData
                this.series = [newVal.male, newVal.female];
                this.chartOptions.labels = ['الذكور', 'الإناث'];
            },
        },
    },
};
</script>

<style scoped>
.chart-container {
    width: 100%;
    padding: 8px; /* Add padding if necessary */
}

.chart-container .apexcharts-canvas {
    width: 100% !important;
}
</style>